import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

const SeoContext = createContext();

export const useSeo = () => {
    const context = useContext(SeoContext);
    if (!context) {
        throw new Error('useSeo must be used within a SeoProvider');
    }
    return context;
};

// Deep comparison helper to check if SEO data actually changed
const areEqual = (prev, next) => {
    if (prev === next) return true;
    if (!prev || !next) return false;
    
    return (
        prev.title === next.title &&
        prev.description === next.description &&
        prev.canonical === next.canonical &&
        prev.robots === next.robots &&
        prev.og?.title === next.og?.title &&
        prev.og?.description === next.og?.description &&
        prev.og?.image === next.og?.image
    );
};

export const SeoProvider = ({ children }) => {
    const [pageSeo, setPageSeo] = useState(null);
    const previousSeoRef = useRef(null);

    const setPageSeoOptimized = useCallback((newSeo) => {
        // Only update if SEO data actually changed
        if (!areEqual(previousSeoRef.current, newSeo)) {
            previousSeoRef.current = newSeo;
            setPageSeo(newSeo);
        }
        // If data unchanged, skip update to prevent infinite loops
    }, []);

    return (
        <SeoContext.Provider value={{ pageSeo, setPageSeo: setPageSeoOptimized }}>
            {children}
        </SeoContext.Provider>
    );
};

